import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Admin, AdminBgProcess } from '../models/admin.model';
import { Entity } from '../models/entity.model';
import { ConfigService } from './config.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import * as utils from '../../shared/helpers/utils';
import { Pagination } from '../models/pagination.model';
import { User } from '../models/user.model';



@Injectable({
  providedIn: 'root'
})
export class AdminService {

  admin: Admin = new Admin;

  public currentAdminSubject: BehaviorSubject<Admin> = new BehaviorSubject(this.admin);
  public currentAdmin!: Observable<Admin>;


  constructor(
    private httpClient: HttpClient,
    private configSvc: ConfigService,
  ) { }

  

  public get currentAdminValue(): Admin {
    return this.currentAdminSubject.value;
  }

  public setCurrentAdmin(_admin: Admin) {
    this.currentAdminSubject.next(_admin);
  }

  public setCurrentAdminParam(_param: string, _value: any) {
    this.currentAdminValue[_param] = _value;
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setAdminPersistanceParamsValue(_key: string, _value: any) {
    !this.currentAdminValue.persistance ? this.currentAdminValue.persistance = {} : null;
    !this.currentAdminValue.persistance[_key] ? this.currentAdminValue.persistance[_key] = [] : null;
    this.currentAdminValue.persistance[_key] = _value;
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setAdminPackageTargetParamsValue(_target: string, _key: string, _value: any) {
    this.currentAdminValue.packages[_target]![_key] = _value;
    this.currentAdminSubject.next(this.currentAdminValue);
  }
  public setAdminPackageParamsValue(_key: string, _value: any) {
    this.currentAdminValue.packages[_key] = _value;
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setAdminPackagesCollectionAcumulateValue(_key: string, _value: any) {
    this.currentAdminValue.packages.collection![_key] = [...this.currentAdminValue.packages.collection![_key], ..._value]
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setAdminPackagesCollectionValue(_key: string, _value: any) {
    this.currentAdminValue.packages.collection![_key] = _value
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setModPackagesParamsValue(_target: string, _param: string, _key: string, _value: any) {
    this.currentAdminValue.packages[_target]![_param]![_key] = _value;
    this.currentAdminSubject.next(this.currentAdminValue);
  }

  public setBgProcessParamsValue(_target: string, _process: string, _value: AdminBgProcess) {
    this.currentAdminValue.bgProcesses[_target]!.filter((item: AdminBgProcess) => item.name === _process)[0] = _value;
    console.log(this.currentAdminValue);
    this.currentAdminSubject.next(this.currentAdminValue);
  }




searchFiltering(_search: string, _typeData: string): Observable<any> {
  let entities: Entity[] = this.configSvc.currentConfigValue.entities;

  // Filter out Optics (entityTypeId = 4) for bulk entity creation
  if (_typeData === 'bulkEntityCreation') {
    entities = entities.filter((e: Entity) => e.entityTypeId !== 4);
  }

  if (!_search.length) {
    return of(this.crearJerarquia(entities, false, _typeData));
  }

  const searchLower = _search.toLowerCase();

  // Build a dictionary id → entity for instant lookups
  const entityMap = new Map<any, Entity>(entities.map((e: Entity) => [e.id, e]));

  // Save the ids of all entities that match the search
  const matchingIds = new Set<any>(
    entities
      .filter((e: Entity) => e.name.toLowerCase().includes(searchLower))
      .map((e: Entity) => e.id)
  );
  // Go over all entities and include those whose name, parent or grandparent matches
  const filteredEntities = entities.filter((item: Entity) => {
    // The entity itself matches
    if (matchingIds.has(item.id)) return true;

    // The parent matches
    const parent = item.parentEntityId != null ? entityMap.get(item.parentEntityId) : null;
    if (parent && matchingIds.has(parent.id)) return true;

    // The grandparent matches
    const grandparent = parent?.parentEntityId != null ? entityMap.get(parent.parentEntityId) : null;
    if (grandparent && matchingIds.has(grandparent.id)) return true;

    return false;
  });

  return of(this.crearJerarquia(filteredEntities, false, _typeData));
}


  obtenerYJerarquizarJson(_typeData: string, _customTreeNode?: Entity[], _entityType?: number): Observable<any> {
    switch (_typeData) {
      case 'bulkEntityCreation':
        // Filter out Optics (entityTypeId = 4) for bulk entity creation
        const filteredEntities = this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId !== 4)!;
        return of(this.crearJerarquia(filteredEntities, true, _typeData));
      case 'locatedList':
        let parentEntities: Entity[] = [];
        if (this.configSvc.currentConfigValue.user?.roleId === 2) {
          parentEntities = this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId !== 4)!;
          parentEntities.push(this.configSvc.currentConfigValue.userEntity!);
        } else {
          parentEntities = this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId !== 4)!;
        }
        return of(this.crearJerarquia(parentEntities, true, _typeData, _entityType));
      case 'located':
        return of(this.crearJerarquia(_customTreeNode!, true, _typeData, _entityType));
      case 'policy':
      case 'newTeam':
        return of(this.crearJerarquia(_customTreeNode!, true, _typeData));
      default:
        return of(this.crearJerarquia(this.configSvc.currentConfigValue.childEntities!, true));
    }
  }
  // Método para jerarquizar los datos
  public crearJerarquia(data: any[], _persist: boolean, _typeData?: string, _entityType?: number): any[] {
    if (_persist) this.configSvc.setConfigParamsValue('entities', data);
    let elementos: { [key: number]: any } = {};
    let jerarquia: any[] = [];

    // Primero, indexamos todos los elementos por su id
    data.forEach(item => {
      elementos[item.id] = item;
      item.children = []; // Inicializamos la propiedad children
    });

    // Ahora, construimos la jerarquía
    data = data.sort((a, b) => a.name.localeCompare(b.name));
    data.forEach(item => {
      let parentId = item.parentEntityId;
      if (parentId !== null && parentId !== undefined) {
        // Si tiene un parentEntityId, lo agregamos como hijo del elemento padre
        if (elementos[parentId]) {
          /*if(item.entityTypeId===3){
            item.level= 1;
          }else{
            item.level= 2;
          } 
          item.expandable= true;*/
          if (item.entityTypeId >= 2) {
            item.parentEntity = { name: elementos[parentId].name, entityTypeId: elementos[parentId].entityTypeId }
          }
          if (elementos[elementos[parentId].parentEntityId]) item.level = 2
          else item.level = 1;
          switch (_typeData) {
            case 'locatedList':
            case 'located':
              switch (_entityType) {
                case 3:
                  break;
                default:
                  elementos[parentId].children.push(item);
                  elementos[parentId].expandable = true;
                  break;
              }
              break;
            case 'policy':
            case 'newTeam':
              break;
            default:
              elementos[parentId].children.push(item);
              elementos[parentId].expandable = true;
              break;
          }

        } else {
          /*item.level= 0;
          item.expandable= true;*/
          switch (_typeData) {
            case 'policy':
            case 'newTeam':
              if (item.entityTypeId === 2) {
                item.level = 0;
                jerarquia.push(item);
              }
              break;
            default:
              item.level = 0;
              jerarquia.push(item);
              break;
          }
        }
      } else {
        // Si no tiene parentEntityId, lo agregamos a la jerarquía principal
        item.level = 0;
        jerarquia.push(item);
      }
    });

    return jerarquia;
  }

  execKron(params?: any): Observable<Pagination<User>> {
    return this.httpClient.get<any>(environment.apiUrl + '/licenses/refresh', { params: utils.cleanParams(params) });
  }

  bulkCreateEntitiesAndPackagesChunk(data: { csvContent: string; parentEntityId: number; packageConfig: any; downloadCredentialsCsv: boolean }): Observable<any> {
    return this.httpClient.post<any>(environment.apiUrl + '/bulk/entities-packages', data);
  }

  bulkCreateUsersChunk(data: { csvContent: string }): Observable<any> {
    return this.httpClient.post<any>(environment.apiUrl + '/bulk/users', data);
  }

  bulkCreateAllChunk(data: { csvContent: string; parentEntityId: number; packageConfig: any; downloadCredentialsCsv: boolean }): Observable<any> {
    return this.httpClient.post<any>(environment.apiUrl + '/bulk/entities-packages-users', data);
  }

}
